import { useContext, useEffect, useState } from "react"
import API from "./API"
import { AdminPersonsResponse } from "../../backend/src/api/dto"
import dayjs from 'dayjs'
import { lookupNameFromObjectsArray } from "./global"
import { Link } from "react-router"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { personSorts, personStatuses, personTypes, yesNo } from "./constants"
import { ModalContext } from './ModalContext';
import AdminUploadXLS from "./Modal/AdminUploadXLS"
import AdminLevel from "./AdminLevel"
import TableData from "./components/TableData"
import { TableColumn } from "./interfaces"

function Persons() {
    const [showModal, closeModal] = useContext(ModalContext);
    const [loading, setLoading] = useState<boolean>(false);

    const [data, setData] = useState<AdminPersonsResponse>({
        persons: [],
        centers: [],
        companies: [],
        positions: []
    })

    useEffect(() => {
        setLoading(true);
        API.getPersons({ divisionMatch: 'true' }).then(res => {
            setLoading(false);
            setData(res)
        }).catch(() => {
            setLoading(false);
        });
    }, [])

    const tableColumns: TableColumn[] = [
        { key: 'nameId', title: 'ID osoby' },
        { key: 'name', title: 'Meno', fn: (user: any) => <Link to={"/dashboard/person/" + user.personId}>{user.name}</Link> },
        { key: 'surname', title: 'Priezvisko', fn: (user: any) => <Link to={"/dashboard/person/" + user.personId}>{user.surname}</Link> },
        { key: 'sort', title: 'Druh', fn: (user: any) => lookupNameFromObjectsArray(personSorts, 'id', user.sort) },
        { key: 'type', title: 'Typ', fn: (user: any) => lookupNameFromObjectsArray(personTypes, 'id', user.type) },
        { key: 'centerId', title: 'Stredisko', fn: (user: any) => lookupNameFromObjectsArray(data.centers, 'centerId', user.centerId) },
        { key: 'companyId', title: 'Firma', fn: (user: any) => lookupNameFromObjectsArray(data.companies, 'companyId', user.companyId) },
        { key: 'status', title: 'Stav', fn: (user: any) => lookupNameFromObjectsArray(personStatuses, 'id', user.status) },
        { key: 'positionId', title: 'Pozícia', fn: (user: any) => lookupNameFromObjectsArray(data.positions, 'positionId', user.positionId) },
        { key: 'startDate', title: 'Štart', className: (user: any) => user.stillWorks ? 'bg-success-subtle' : '', fn: (user: any) => user.startDate ? dayjs(user.startDate).format('YYYY-MM-DD') : null },
        { key: 'endDate', title: 'Koniec', className: (user: any) => user.stillWorks ? 'bg-success-subtle' : '', fn: (user: any) => user.endDate ? dayjs(user.endDate).format('YYYY-MM-DD') : null },
        { key: 'email', title: 'E-mail' },
        { key: 'monthOvertimeHours', title: 'Nadčasy', fn: (user: any) => lookupNameFromObjectsArray(yesNo, 'id', user.monthOvertimeHours) },
        { key: 'nonWorkingDayEntries', title: 'NWDE', fn: (user: any) => lookupNameFromObjectsArray(yesNo, 'id', user.nonWorkingDayEntries) },
        { key: 'maxDayHours', title: 'MDH' },
        { key: 'stdDayHours', title: 'SDH' },
        { key: 'adminLevel', title: 'Admin' },
        { key: 'actions', title: 'Akcia', className: 'text-center', style: { width: '110px' }, fn: (user: any) => <Link className="btn btn-primary btn-sm" to={"/dashboard/person/" + user.personId}><FontAwesomeIcon fixedWidth icon={["fas", "pen"]} /> Upraviť</Link> }
    ]

    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header" style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-6">
                            <h5 className="mt-2">
                                <FontAwesomeIcon fixedWidth icon={["fas", "person"]} /> Osoby
                            </h5>
                        </div>
                        <div className="col-6 text-end">
                            <AdminLevel level={9} match="greaterOrEqual">
                                <button className="btn btn-success me-3" onClick={() => showModal(
                                    <AdminUploadXLS
                                        where="osôb"
                                        table="person"
                                    />
                                )}><FontAwesomeIcon fixedWidth icon={["fas", "upload"]} /> Nahrať z XLSX</button>
                            </AdminLevel>
                            <a href={API.getDownloadUrl('person')} className="btn btn-primary me-3"><FontAwesomeIcon fixedWidth icon={["fas", "download"]} /> Stiahnuť ako XLSX</a>
                            <AdminLevel level={9} match="greaterOrEqual">
                                <Link to="/dashboard/person/0" className="btn btn-success"><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať osobu</Link>
                            </AdminLevel>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <TableData tableColumns={tableColumns} rows={data.persons} data={data} loading={loading} />
                </div>
            </div>

            <AdminLevel level={2} match="equal">
                <div className="alert alert-warning mt-5" role="alert">
                    <FontAwesomeIcon icon={["fas", "exclamation-triangle"]} className="me-2" />
                    Schvalovateľ+
                    <ul>
                        <li>vidí len osoby ktoré majú centrá v rovnakej divízii ako on</li>
                        <li>nemôže pridávať užívateľov</li>
                    </ul>

                </div>


            </AdminLevel>

        </div>
    )
}

export default Persons